module.exports = __webpack_public_path__ + "static/media/juegoComparando.92cc680a.png";